import React, { useEffect, useState } from 'react';
import { BiUser, BiLogOutCircle, BiHome, BiCalendarEvent } from 'react-icons/bi';
import { MdEvent } from 'react-icons/md';
import { FaGraduationCap, FaHandshake } from 'react-icons/fa';
import { RxSpeakerLoud } from 'react-icons/rx';
import { IoMdBusiness } from 'react-icons/io';
import { CgWebsite } from 'react-icons/cg';
import { Sidebar, NavItemsContainer, NavItem } from 'react-sidebar-web';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Navbar } from 'responsive-navbar-react';
import 'responsive-navbar-react/dist/index.css';
import { BASE_URL } from '../../settings';

// 👇️ pages
import AdminHome from './AdminHome';
import Admin_Alumni from './Admin_Alumni';
import Admin_AlumniDetail from './Admin_AlumniDetail';
import Admin_Events from './Admin_Events/Admin_Events';
import Admin_EventDetail from './Admin_Events/Admin_EventDetail';
import Admin_AddEvent from './Admin_Events/Admin_AddEvent';
import Admin_EditEvent from './Admin_Events/Admin_EditEvent';
import Admin_Announcements from './Admin_Announcements';
import Admin_EditAnnouncement from './Admin_EditAnnouncement';
import Admin_AnnouncementDetail from './Admin_AnnouncementDetail';
import Admin_AddAnnouncement from './Admin_AddAnnouncement';
import Admin_JobPosts from './Admin_JobPosts';
import Admin_AddJobPost from './Admin_AddJobPost';
import Admin_EditJobPost from './Admin_EditJobPost';
import AdminJobPostDetail from './Admin_JobPostDetail';

export default function AdminDashboard({
    adminData,
    setScreen,
    alumni,
    events,
    announcements,
    jobPosts,
    fetchAllAlumni,
    fetchAnnouncements,
    fetchJobPosts,
    fetchEvents,
}) {
    const [pageAtTop, setPageAtTop] = useState(false);
    const [alumniCount, setAlumniCount] = useState(0);
    const [announcementsCount, setAnnouncementsCount] = useState(0);
    const [jobPostsCount, setJobPostsCount] = useState(0);
    const [eventsCount, setEventsCount] = useState(0);
    const [fetched_alumni, setFetchedAlumni] = useState({});
    const [fetched_announcement, setFetchedAnnouncement] = useState({});
    const [fetched_jobPost, setFetchedJobPost] = useState({});
    const [fetched_event, setFetchedEvent] = useState({});
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [page, setPage] = useState('Home');
    const navigate = useNavigate();
    const { clientWidth } = document.body;

    useEffect(() => {
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';
        document.onscroll = () => {
            window.scrollY == 0 ? setPageAtTop(true) : setPageAtTop(false);
        };
        window.scrollTo({ top: 0, behavior: 'smooth' });
        fetchAlumniCount();
        fetchAnnouncementsCount();
        fetchJobPostsCount();
        fetchEventsCount();
    }, []);

    // 👇️ handler to fetch alumni count from server
    const fetchAlumniCount = async () => {
        try {
            fetch(`${BASE_URL}/alumni/count`).then(async (result) => {
                let response = await result.json();
                if (response?.count && Number(response?.count))
                    setAlumniCount(Number(response?.count));
                else setAlumniCount(0);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch announcements count from server
    const fetchAnnouncementsCount = async () => {
        try {
            fetch(`${BASE_URL}/announcements/count`).then(async (result) => {
                let response = await result.json();
                if (response?.count && Number(response?.count))
                    setAnnouncementsCount(Number(response?.count));
                else setAnnouncementsCount(0);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch job posts count from server
    const fetchJobPostsCount = async () => {
        try {
            fetch(`${BASE_URL}/jobs/count`).then(async (result) => {
                let response = await result.json();
                if (response?.count && Number(response?.count))
                    setJobPostsCount(Number(response?.count));
                else setJobPostsCount(0);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch events count from server
    const fetchEventsCount = async () => {
        try {
            fetch(`${BASE_URL}/events/count`).then(async (result) => {
                let response = await result.json();
                if (response?.count && Number(response?.count))
                    setEventsCount(Number(response?.count));
                else setEventsCount(0);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch an alumni by id
    const fetchAlumniById = (id) => {
        try {
            fetch(`${BASE_URL}/alumni/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            }).then(async (result) => {
                let response = await result.json();
                let the_alumni = response?.alumni;
                setFetchedAlumni(the_alumni);
                navigate(`/admin.console/alumni/fetch/${the_alumni?.uuid}`);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch an event by id
    const fetchEventById = (id) => {
        try {
            fetch(`${BASE_URL}/events/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            }).then(async (result) => {
                let response = await result.json();
                let event = response?.event;
                setFetchedEvent(event);
                navigate(`/admin.console/events/fetch/${event?.uuid}`);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch an announcement by id
    const fetchAnnouncementById = (id) => {
        try {
            fetch(`${BASE_URL}/announcements/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            }).then(async (result) => {
                let response = await result.json();
                let fetched_announcement = response?.announcement;
                setFetchedAnnouncement(fetched_announcement);
                navigate(`/admin.console/announcements/fetch/${fetched_announcement?.uuid}`);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to fetch a job post by id
    const fetchJobPostById = (id) => {
        try {
            fetch(`${BASE_URL}/jobs/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            }).then(async (result) => {
                let response = await result.json();
                let fetched_job_post = response?.job_post;
                setFetchedJobPost(fetched_job_post);
                navigate(`/admin.console/jobposts/fetch/${fetched_job_post?.uuid}`);
            });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to logout Admin
    const logoutAdmin = async () => {
        try {
            fetch(`/admin/signout`, {
                method: 'POST',
            })
                .then(async (result) => {
                    setShowLoading(false);
                    setError(null);
                    let response = await result?.json();
                    if (response?.msg === null) {
                        setError(response?.errorMsg);
                    } else {
                        console.log(response);
                        setMessage(response?.msg);
                        setScreen('Login');
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        setError('Could not reach the servers');
                    } else {
                        setError('Some error occurred!');

                        console.log('the error:', error);
                    }
                    setShowLoading(false);
                    setMessage(null);
                });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // props for the nav bar
    const props = {
        items: [
            {
                text: <span onClick={() => navigate('/admin.console')}>Home</span>,
            },
            {
                text: <span onClick={() => navigate('/admin.console/alumni')}>Alumni</span>,
            },
            {
                text: (
                    <span onClick={() => navigate('/admin.console/announcements')}>
                        Announcements
                    </span>
                ),
            },
            {
                text: <span onClick={() => navigate('/admin.console/jobosts')}>Job posts</span>,
            },
            {
                text: <span onClick={logoutAdmin}>Logout</span>,
            },
            {
                text: <span onClick={() => navigate('/')}>Alumni Website</span>,
            },
        ],
        logo: {
            text: <BiHome size={30} onClick={() => navigate('/admin.console')} />,
        },
        style: {
            barStyles: {
                background: 'darkblue',
                paddingTop: 10,
                paddingBottom: 10,
                zIndex: 10000000,
                boxShadow: pageAtTop ? 'none' : '5px 5px 35px #000',
                transition: 'all .25 ease-out',
                // marginLeft: clientWidth <= 575.97 ? '0' : '2rem',
            },
            sidebarStyles: {
                background: 'darkblue',
                buttonColor: 'white',
            },
        },
        // float: true,
    };

    return (
        <>
            {/* Nav Bar section  */}
            {clientWidth <= 1199 && <Navbar {...props} />}

            {clientWidth > 1199 && (
                <Sidebar className='admin-dashboard-sidebar'>
                    <NavItemsContainer>
                        <NavItem
                            label='Home'
                            to='/admin.console'
                            onClick={() => navigate('/admin.console')}
                            icon={<BiHome />}
                        />
                        <NavItem
                            label='Alumni'
                            to='/admin.console/alumni'
                            icon={<FaGraduationCap />}
                            onClick={() => navigate('/admin.console/alumni')}
                        />
                        <NavItem
                            label='Events'
                            to='/admin.console/events'
                            icon={<MdEvent />}
                            onClick={() => navigate('/admin.console/events')}
                        />
                        <NavItem
                            label='Announcements'
                            to='/admin.console/announcements'
                            icon={<RxSpeakerLoud />}
                            onClick={() => navigate('/admin.console/announcements')}
                        />
                        <NavItem
                            label='Job Posts'
                            to='/admin.console/jobposts'
                            icon={<IoMdBusiness />}
                            onClick={() => navigate('/admin.console/jobposts')}
                        />
                        <NavItem
                            label='Alumni Website'
                            to='/'
                            icon={<CgWebsite />}
                            onClick={() => navigate('/')}
                        />
                        <NavItem
                            label='Logout'
                            to={'#'}
                            onClick={logoutAdmin}
                            icon={<BiLogOutCircle />}
                        />
                    </NavItemsContainer>
                </Sidebar>
            )}
            <Routes>
                <Route
                    path='/'
                    element={
                        <AdminHome
                            adminData={adminData}
                            alumniCount={alumniCount}
                            announcementsCount={announcementsCount}
                            jobPostsCount={jobPostsCount}
                            eventsCount={eventsCount}
                            alumni={alumni}
                            events={events}
                            announcements={announcements}
                            jobPosts={jobPosts}
                            setPage={setPage}
                            fetchAlumniById={fetchAlumniById}
                            fetchAnnouncementById={fetchAnnouncementById}
                            fetchJobPostById={fetchJobPostById}
                            fetchEventById={fetchEventById}
                        />
                    }
                />
                <Route
                    path='/alumni'
                    element={
                        <Admin_Alumni
                            alumni={alumni}
                            fetchAllAlumni={fetchAllAlumni}
                            fetchAlumniById={fetchAlumniById}
                        />
                    }
                />
                <Route
                    path='/alumni/fetch/:uuid'
                    element={
                        <Admin_AlumniDetail
                            alumni={fetched_alumni}
                            fetchAllAlumni={fetchAllAlumni}
                        />
                    }
                />

                <Route
                    path='/events'
                    element={
                        <Admin_Events
                            events={events}
                            fetchEventById={fetchEventById}
                            fetchEvents={fetchEvents}
                        />
                    }
                />
                <Route
                    path='/events/fetch/:uuid'
                    element={<Admin_EventDetail event={fetched_event} fetchEvents={fetchEvents} />}
                />
                <Route
                    path='/events/edit/:uuid'
                    element={
                        <Admin_EditEvent
                            event={fetched_event}
                            fetchEventById={fetchEventById}
                            fetchEvents={fetchEvents}
                        />
                    }
                />

                <Route path='/events/new' element={<Admin_AddEvent fetchEvents={fetchEvents} />} />

                <Route
                    path='/announcements'
                    element={
                        <Admin_Announcements
                            announcements={announcements}
                            fetchAnnouncementById={fetchAnnouncementById}
                            fetchAnnouncements={fetchAnnouncements}
                        />
                    }
                />
                <Route
                    path='/announcements/fetch/:uuid'
                    element={
                        <Admin_AnnouncementDetail
                            announcement={fetched_announcement}
                            fetchAnnouncements={fetchAnnouncements}
                        />
                    }
                />
                <Route
                    path='/announcements/edit/:uuid'
                    element={
                        <Admin_EditAnnouncement
                            announcement={fetched_announcement}
                            fetchAnnouncements={fetchAnnouncements}
                            fetchAnnouncementById={fetchAnnouncementById}
                        />
                    }
                />

                <Route
                    path='/announcements/new'
                    element={<Admin_AddAnnouncement fetchAnnouncements={fetchAnnouncements} />}
                />

                <Route
                    path='/jobposts'
                    element={
                        <Admin_JobPosts
                            setPage={setPage}
                            jobPosts={jobPosts}
                            fetchJobPostById={fetchJobPostById}
                            fetchJobPosts={fetchJobPosts}
                        />
                    }
                />
                <Route
                    path='/jobposts/new'
                    element={<Admin_AddJobPost fetchJobPosts={fetchJobPosts} />}
                />
                <Route
                    path='/jobposts/fetch/:uuid'
                    element={
                        <AdminJobPostDetail
                            job_post={fetched_jobPost}
                            fetchJobPosts={fetchJobPosts}
                        />
                    }
                />
                <Route
                    path='/jobposts/edit/:uuid'
                    element={
                        <Admin_EditJobPost
                            job_post={fetched_jobPost}
                            fetchJobPosts={fetchJobPosts}
                            fetchJobPostById={fetchJobPostById}
                        />
                    }
                />
            </Routes>
        </>
    );
}
